import React from 'react'
import BuyGetTop from '../../assets/images/BuyGetTop.png'
import DoubleVcoinreward from '../../assets/images/DoubleVcoinreward.png'
import Vbackplan from '../../assets/images/Vbackplan.png'
import VCoinallocation  from '../../assets/images/VCoinallocation .png'
import CoinImage  from '../../assets/images/VCoin.png'
import styled from 'styled-components';
import ImageSilder from './ImageSilder'
import AppsData from 'Pages/AppsData/AppsData'


const HeadingDiv = styled.div`
  width:${window.screen.width > 767 ?"70%":"97%"};
  display:flex;
  justify-content:center;
  align-items:center;
  flex-direction:column;
  padding-top:${window.screen.width > 767 ?"30px":"15px"};
  text-align:center;
  margin:auto;  
  p{
  font-size:${window.screen.width > 767 ?"18px":"15px"};
  font-weight:100;
  margin-bottom:20px;
  }
`;

const StyledButton = styled.button`
  padding: 12px 54px;
  background-color: #4b0082;
  color: white;
  border: 1px solid #FFDF00;
  border-radius: 25px;
  font-size: 15px;
  font-weight: 300;
  cursor: pointer;
  transition: 0.3s ease;
  margin-top:20px;
  &:hover {
  border: 1px solid white;
    background-color: white;
    color: #4b0082;
  }
`;

const Wrapper = styled.div`
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  width:${window.screen.width > 767 ?"70%":"97%"};   
  margin:auto; 
`;

const Title = styled.span`
  color: #FFD700;
  font-size:${window.screen.width > 767 ?"25px":"20px"};
  font-weight:100;  
`;

const Box = styled.div`
  border: 2px solid #FFD700;
  border-radius:10px;
  overflow:hidden;
  padding:${window.screen.width > 767 ?"":"1rem"};
  background-color: #000;
`;

const StyledImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;
`;

const LastBox = styled.div`  
  margin-top:40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  padding:${window.screen.width > 767 ?"":"1rem"};
  span{
    color: #FFD700;    
    font-size:${window.screen.width > 767 ?"25px":"20px"};
    width:100%; 
    display:block;
    text-align:center;
  }

`;

// const RoundBox = styled.div`  
//   width:${window.screen.width > 767?"66%":"97%"};  
//   border:1px solid #555555;
//   border-radius:10px;
//   margin:20px 0px;
//   padding:20px;
//   p{    
//   padding:10px 0px;
//   font-size:
//   }
// `;

const TopContainer = styled.div`
  display: flex;
  // flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  color: white;
  

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

const Image = styled.img`
  width: 140px;
  height: 140px;
  object-fit: contain;
  // margin-bottom: 20px;

  @media (min-width: 768px) {
    margin-right: 40px;
    margin-bottom: 0;
    width: 140px;
    height: 140px;
  }
`;

const TextWrapper = styled.div`
  text-align: center;

  @media (min-width: 768px) {
    // text-align: left;
  }
`;

const Heading = styled.h2`
  font-size: 25px;
  font-weight: bold;
  margin: 0;
  @media (max-width: 767px) {
    font-size: 18px;
  }
`;

const SubHeading = styled.h2`
  font-size: 25px;
  font-weight: bold;
  margin-bottom: 10px;
   @media (max-width: 767px) {
    font-size: 18px;
  }
`;

const Description = styled.p`
margin-top:10px;
  font-size: 18px;
  font-weight: 600;
  @media (max-width: 767px) {
      font-size: 13px;
    }
`;

const screenSize =window.screen.width >767 ?true:false

function BuyGet() {  

  return (
    <div>
      <div className='d-flex justify-content-center py-4'>
        <TopContainer>
        {/* <Image src={CoinImage} alt="Vcoin" /> */}
        <TextWrapper>
          <Heading className='text-center text-uppercase ' style={{color: "#FFD700"}}>Buy Collectibles, Get Vcoin Back.</Heading>
          {/* <SubHeading className='text-center'>PAYS OFF</SubHeading> */}
          <Description className='text-center'>
          Every purchase gives you Vcoin to stack, spend, or save.
          </Description>          
        </TextWrapper>
      </TopContainer>
      </div>
      <div className='w-100 d-flex justify-content-center py-3'>
      <ImageSilder/>
      </div>
      <div className='py-2' style={{marginTop: "-30px"}}>
      <AppsData/>
      </div>
    <HeadingDiv>
            <Title>Double Your Vcoin Rewards</Title>
            <p>Tag your collectibles. Earn twice the value</p>
    </HeadingDiv>    
    <Wrapper>
      <div className="container">
        <div className="row align-items-center">
          {/* Left Side */}
          <div className="col-md-6 mb-4 mb-md-0">            
            <div className="">
              <p className='fs-4 fw-lighter'>How It Works</p>
              <p className='fs-6 fw-lighter'>
                Buy any collectible ➝ Get rewarded in Vcoins <br/> instantly 
                Post your collectible and tag us on social ➝ Earn double
              </p>
              <br />
              <p className='fs-6 fw-lighter'>
                Apply with your post link ➝ Bonus sent to your wallet
              </p>
              <br />
              <p className='fs-6 fw-lighter'>Vcoin is a loyalty reward. Not a security</p>
            </div>
          </div>

          {/* Right Side */}
          <div className="col-md-6">
            <Box>
              <StyledImage
                src={DoubleVcoinreward}
                alt="Vcoin x2 Promo"
              />
            </Box>
          </div>
        </div>
      </div>
    </Wrapper>   

    <HeadingDiv className='py-5'>
            <Title>What’s Vcoin?</Title>
            <p>Your reward for every action. Built on Solana. Limited to 21B.</p>            
            <img src={Vbackplan} alt="" width={screenSize?"":"100%"}/>
    </HeadingDiv> 

    <HeadingDiv className='pb-5'>
            <Title>Only 21,000,000,000 Vcoins Exist.</Title>
            <p>Here’s how it’s distributed:</p>                
            <img src={VCoinallocation} alt="" width={screenSize?"100%":"100%"}/>
            {/* <StyledButton>
                  BUY & GET
            </StyledButton> */}
    </HeadingDiv> 

    </div>
  )
}

export default BuyGet
